<template>
    <!-- Tools -->
    <div id="compound-interest" class="p-1">
        <div class="row mb-base">
            <div class="col-sm-12 col-md-4 col-lg-4 mb--30">
                <div class="row mt-5 simulation-form bg-color-light-gray">
                    <h5 class="bold mb-0">Calcula tu inversión</h5>

                    <div class="col mt-3 col-12">
                        <label class="vs-input--label">Inversión inicial</label>
                        <input class="" type="text" v-model.lazy="fixedInvestmentAmountMoney" v-money="money"
                        name="fixedInvestmentAmountMoney" :min="1" autocomplete="off" placeholder="0" />
                        <p v-if="errorMssg" class="error-alert mb-0">{{ errorMssg }}</p>
                    </div>
                    <!-- <div class="col mt-3 col-12">
                        <label class="vs-input--label">Inversión adicional</label>
                        <input class="" type="text" v-model.lazy="extraInvestmentAmountMoney" v-money="money"
                            name="extraInvestmentAmountMoney" :min="1" autocomplete="off" placeholder="0" />
                    </div> -->
                    <!-- <div class="col-12 mt-3">
                      <label class="vs-input--label">Inversión inicial</label><br>
                      <label class="vs-input--label bold">{{ this.explicitMoneyFormat(totalFixedInvestment) }}</label>
                    </div> -->
                    <div class="col col-12">
                        <button class="mt-5 axil-btn rg-btn-dark rg-style-button" type="border"
                            @click.stop="calculateInterest">Calcular</button>
                    </div>
                </div>

            </div>
            <div class="col-sm-12 col-md-8 col-lg-8 padding-chart mt-auto text-align-last">
                <div class="row mb-2">
                    <div class="col-12">
                        <h5 class="bold mb-0">¡Tu ingreso pasivo en 20 años será de {{explicitMoneyFormat(totalFixedInvestmentAfterYears, 0)}} ({{ explicitMoneyFormat(periodIncomeAmount, 0) }} por mes)!*</h5>
                        <small class="mt-1 italic"><i>*Estimación en función de resultados históricos globales de
                            RedGirasol.</i></small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <vue-apex-charts type="line" height="400" :options="chartOptions"
                            :series="series"></vue-apex-charts>
                            <small class="bold"><i>*Tu plan no tiene un plazo forzoso, puedes pausarlo, modificarlo o cancelarlo en cualquier momento.</i></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import formatHelper from '@mixins/formatHelper';
import VueApexCharts from 'vue-apexcharts';
import { VMoney } from 'v-money'
import currencyHelper from "@mixins/currencyHelper";

export default {
  name: "PassiveIncomeSimulator",
  components: {
    VueApexCharts
  },
  mixins: [formatHelper, currencyHelper],
  directives: { money: VMoney },
  props: {
    defaultFixedInvestmentAmount: { type: [String, Number], default: 10000 },
    planDetails: { type: [Object], default: null }, // eliminar
  },
  data() {
    return {
      fixedInvestmentAmountMoney: this.currencyFormat(this.defaultFixedInvestmentAmount),
      totalFixedInvestmentAfterYears: 0,
      extraInvestmentAmountMoney: 0,
      periodIncomeAmount: 0,
      errorMssg: null,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        suffix: '',
        precision: 0,
        masked: false
      },
      series: [{
        name: "",
        data: []
      }],
      chartOptions: {
        chart: {
          zoom: {
            enabled: true
          },
          toolbar: {
            tools: {
              download: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
            autoSelected: 'none'
          },
          locales: [{
            "name": "en",
            "options": {
              "toolbar": {
                "exportToPNG": "Descargar PNG",
                "exportToCSV": "Descargar CSV",
                "selectionZoom": "Zoom en área",
                "zoomIn": "Acercar",
                "zoomOut": "Alejar",
                "pan": "Paneo",
                "reset": "Reestablecer"
              }
            }
          }],
          defaultLocale: "en"
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        colors: ['#28de18', '#545454'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
            categories: [],
            axisTicks: {
                show: true,
            },
            title: {
                text: "Periodo (año)*",
                style: {
                    color: '#2d2d2d',
                },
                tooltip: {
                    enabled: true
                }
            },
        },
        yaxis: [
          {
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#28de18'
            },
            labels: {
              formatter: (value) => { return this.explicitMoneyFormat(value, 2) }
            },
            title: {
              text: "Valor de tu cuenta",
              style: {
                color: '#28de18',
              }
            },
            tooltip: {
              enabled: true
            }
          }
        ],
        noData: {
          text: 'Cargando...'
        }
      },
    }
  },
  async mounted() {
    await this.calculateInterest();
  },
  computed: {
      totalFixedInvestment(){
        return this.unMoneyFormat(this.fixedInvestmentAmountMoney)+this.unMoneyFormat(this.extraInvestmentAmountMoney);
      }
    },
  methods: {
    async calculateInterest() {  
      try {
        let payload = {
          fixed_investment_amount: this.unMoneyFormat(this.fixedInvestmentAmountMoney),
        };
        let response = await this.publicApiPost(`api/v1/calculatePassiveIncome`, payload);
        this.periodIncomeAmount = response.data.period_income_amount;
        let seriesData = [];
          let seriesPlainData = [];
        response.data.chart_data.forEach((f , index) => {
          seriesData.push(f.accumulated_income);
          seriesPlainData.push(f.accumulated_income_plain);
          this.chartOptions.xaxis.categories.push(index+1);
          this.totalFixedInvestmentAfterYears = f.accumulated_income;
          
        });
        this.series = [
          {
            name: "Ingresos acumulados",
            data: seriesData
          },
          {
            name: "Ingreso anual",
            data: seriesPlainData
          }
        ];
      }
      catch (e) {
        this.errorMssg = 'Error en cálculo. No ha sido posible calcular la información, intente más tarde.';
        console.log(e);
      }
    },
  },
};
</script>
<style>
.simulation-form {
    padding: 2rem;
    border-radius: 15px;
}

input {
    background-color: var(--color-white);
    margin-top: 5px;
}

.padding-chart {
    padding-left: 4rem;
    padding-right: 4rem;
}

.error-alert {
    margin-top: 1rem;
    margin-bottom: 0;
    /* background-color: var(--color-pink-shade); */
    /* padding: 1rem; */
    border-radius: 10px;
}

@media only screen and (max-width: 575px) {
    .padding-chart {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }
}

</style>